import {Component, Inject, OnInit} from '@angular/core';
import {APIDialog} from '../../../commons/dialogs/explorer.dialogs';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import {FourDService} from '4d-mapper';

@Component({
  selector: 'app-project-tips-dialog',
  templateUrl: './project-tips-dialog.component.html',
  styleUrls: ['./project-tips-dialog.component.scss']
})
export class ProjectTipsDialogComponent implements OnInit {

  showProjectTips = false;

  constructor(public dialogRef: MatDialogRef<APIDialog>, @Inject(MAT_DIALOG_DATA) public data: any,private fourD:FourDService) {

  }

  ngOnInit() {
    if ( this.fourD.activeTeam.hasOwnProperty('showProjectTips') ) {
      this.showProjectTips = !this.fourD.activeTeam['showProjectTips'];
    }
  }


  onClick(){

    this.fourD.activeTeam['showProjectTips'] = !this.showProjectTips;
    this.fourD.activeTeam.saveObservable().subscribe();

    this.dialogRef.close(true);
  }

}
